export default __webpack_public_path__ + "static/media/02_malina.0d396f19.jpg";